module.exports = __webpack_public_path__ + "img/CTWP__Shield_02.413a91a4.png";